import PropTypes from 'prop-types';

export default function user(state) {
  return {
    use(name) {
      if (!this.has(name)) {
        // eslint-disable-next-line no-throw-literal
        throw `Theme '${name}' wasn't found`;
      }

      const descriptor = this.get(state.active = name);

      state.publish(descriptor);
      return descriptor;
    },
  };
}

user.stateTypes = {
  active: PropTypes.string.isRequired,
  publish: PropTypes.func.isRequired,
};
